module.exports = __webpack_public_path__ + "img/nationalEmblem.d0289dc0.png";